import { useState } from 'react'
import {
  Accordion,
  Badge,
  Group,
  Paper,
  Stack,
  Text,
  Title,
  Switch,
} from '@mantine/core'
import { usePlanosCompativeisEquipamento } from '../../hooks/usePlanosModelo'
import {
  CATEGORIAS_PLANO,
  PERIODICIDADES,
  labelDe,
} from '../planos_modelo/constants'

interface Props {
  equipamentoId: string
}

export default function PlanosCompativeisSection({ equipamentoId }: Props) {
  const [incluirInativos, setIncluirInativos] = useState(false)
  const lista = usePlanosCompativeisEquipamento(equipamentoId, incluirInativos)

  return (
    <section
      style={{
        background: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        marginTop: '1rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}
    >
      <Group justify="space-between" mb="sm" align="flex-start">
        <div>
          <Title order={4}>Planos Modelo compatíveis</Title>
          <Text size="xs" c="dimmed">
            Planos do catálogo cujos tipos de equipamento incluem este. Aplique
            a um PMOC pela tela do próprio PMOC (aba "Planos e atividades").
          </Text>
        </div>
        <Switch
          label="Incluir inativos"
          checked={incluirInativos}
          onChange={(e) => setIncluirInativos(e.currentTarget.checked)}
          data-testid="planos-compativeis-inativos"
        />
      </Group>

      {lista.isLoading ? (
        <Text c="dimmed">Carregando…</Text>
      ) : (lista.data?.results.length ?? 0) === 0 ? (
        <Paper p="md" withBorder>
          <Text c="dimmed">
            Nenhum plano modelo cadastrado para o tipo deste equipamento. Crie
            um em <strong>/planos-modelo</strong>.
          </Text>
        </Paper>
      ) : (
        <Accordion variant="separated">
          {lista.data?.results.map((p) => (
            <Accordion.Item key={p.id} value={p.id}>
              <Accordion.Control>
                <Group gap="xs" wrap="wrap">
                  <Text fw={600}>{p.nome}</Text>
                  <Badge variant="light" color="cyan">
                    {labelDe(p.categoria, CATEGORIAS_PLANO)}
                  </Badge>
                  <Badge variant="light" color="gray">
                    {p.atividades.length} atividades
                  </Badge>
                  {!p.ativo && <Badge color="gray">inativo</Badge>}
                </Group>
              </Accordion.Control>
              <Accordion.Panel>
                {p.descricao && (
                  <Text size="sm" c="dimmed" mb="sm">
                    {p.descricao}
                  </Text>
                )}
                {p.atividades.length === 0 ? (
                  <Text c="dimmed" size="sm">
                    Sem atividades.
                  </Text>
                ) : (
                  <Stack gap="xs">
                    {p.atividades.map((at) => (
                      <Group key={at.id} gap="xs" wrap="wrap">
                        <Text size="sm" fw={500}>
                          • {at.nome}
                        </Text>
                        <Badge size="sm" variant="light">
                          {labelDe(at.periodicidade, PERIODICIDADES)}
                          {at.periodicidade === 'customizada_dias' &&
                          at.periodicidade_customizada_dias
                            ? ` (${at.periodicidade_customizada_dias}d)`
                            : ''}
                        </Badge>
                        {at.exige_foto !== 'nunca' && (
                          <Badge size="sm" color="orange" variant="light">
                            📷 {at.exige_foto === 'obrigatoria' ? 'obrig.' : 'opc.'}
                          </Badge>
                        )}
                        {at.exige_medicao && (
                          <Badge size="sm" color="cyan" variant="light">
                            📊
                          </Badge>
                        )}
                      </Group>
                    ))}
                  </Stack>
                )}
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </section>
  )
}
